import React from "react";
import { Badge, Container } from "react-bootstrap";
import "./TrackOrderDetails.css";
// BsPatchCheckFill
import { BsPatchCheckFill } from "react-icons/bs";
const TrackOrderDetails = () => {
  return (
    <div className="section-container track-order-details">
      <Container>
        <div className="track-order-container">
          <h4 className="fw-light m-0 text-center">Order Tracking</h4>
          <h5 className="fw-bold">Order ID : #JKH6FD4G6SD75</h5>
          <div className="mt-3">
            <div className="order-map">
              <div className="order-step">
                <div className="order-progress">
                  <div className="progress-icon">
                    <BsPatchCheckFill className="fs-4 text-success" />
                  </div>
                </div>
                <span>Order Confirmed</span>
              </div>
              <div className="order-step">
                <div className="order-progress">
                  <div className="progress-icon">
                    <BsPatchCheckFill className="fs-4 text-success" />
                  </div>
                </div>
                <span>Picked by Rider</span>
              </div>
              <div className="order-step">
                <div className="order-progress">
                  <div className="progress-icon">
                    <BsPatchCheckFill className="fs-4 text-success" />
                  </div>
                </div>
                <span>On the Way</span>
              </div>
              <div className="order-step">
                <div className="order-progress">
                  <div className="progress-icon">
                    <BsPatchCheckFill className="fs-4 text-success" />
                  </div>
                </div>
                <span>Ready to Pickup</span>
              </div>
            </div>

            {/* order heading begin  */}
            <div className="row">
              <div className="col-12 col-md-6 col-lg-8 py-2">
                <div className="row">
                  <div className="col-12 col-md-12 col-lg-6 py-2">
                    <h5 className="fw-normal m-0">Products Details</h5>
                    <div className="border p-3 mt-2">
                      <div className="d-flex align-items-center justify-content-between">
                        <span className="fw-light m-0 d-block">Order ID :</span>
                        <span className="fw-light m-0 d-block">
                          #JKH6FD4G6SD75
                        </span>
                      </div>
                      <div className="d-flex align-items-center justify-content-between">
                        <span className="fw-light m-0 d-block">
                          Product Name :
                        </span>
                        <span className="fw-light m-0 d-block">
                          {" "}
                          Men's t-shirt
                        </span>
                      </div>
                      <div className="d-flex align-items-center justify-content-between">
                        <span className="fw-light m-0 d-block">Quantity :</span>
                        <span className="fw-light m-0 d-block"> 5</span>
                      </div>
                      <div className="d-flex align-items-center justify-content-between">
                        <span className="fw-light m-0 d-block">Price :</span>
                        <span className="fw-light m-0 d-block">$ 51.00</span>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-12 col-lg-6 py-2">
                    <h5 className="fw-normal m-0">Order Details</h5>
                    <div className="border p-3 mt-2">
                      <div className="d-flex align-items-center justify-content-between">
                        <span className="fw-light m-0 d-block">Date :</span>
                        <span className="fw-light m-0 d-block">
                          28 July 2022
                        </span>
                      </div>
                      <div className="d-flex align-items-center justify-content-between">
                        <span className="fw-light m-0 d-block">
                          Ordered by :
                        </span>
                        <span className="fw-light m-0 d-block">Mark Otto</span>
                      </div>
                      <div className="d-flex align-items-center justify-content-between">
                        <span className="fw-light m-0 d-block">
                          Ordered Mail :
                        </span>
                        <span className="fw-light m-0 d-block">
                          markotto@gmail
                        </span>
                      </div>
                      <div className="d-flex align-items-center justify-content-between">
                        <span className="fw-light m-0 d-block">
                          Payment Stutus :
                        </span>
                        <Badge bg="success">Paid</Badge>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-12 col-lg-6 py-2">
                    <h5 className="fw-normal m-0">Delivery Address</h5>
                    <div className="border p-3 mt-2">
                      <div className="d-flex align-items-center justify-content-between">
                        <span className="fw-light m-0 d-block">Address Line :</span>
                        <span className="fw-light m-0 d-block">
                          Shawsab Lane, Old dhaka 1202
                        </span>
                      </div>
                      <div className="d-flex align-items-center justify-content-between">
                        <span className="fw-light m-0 d-block">
                            Flat/Building Name :
                        </span>
                        <span className="fw-light m-0 d-block">Carlos Garden</span>
                      </div>
                      <div className="d-flex align-items-center justify-content-between">
                        <span className="fw-light m-0 d-block">
                          Street Name :
                        </span>
                        <span className="fw-light m-0 d-block">
                          120/B link-road,Mexico
                        </span>
                      </div>
                      <div className="d-flex align-items-center justify-content-between">
                        <span className="fw-light m-0 d-block">
                            Postal Code :
                        </span>
                        <span className="fw-light m-0 d-block">
                          1200
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-6 col-lg-4 py-2">
                <h5 className="fw-normal m-0">Order Summary</h5>
                <div className="border p-3 mt-2">
                  <div className="d-flex align-items-center justify-content-between">
                    <span className="fw-light m-0 d-block">Date :</span>
                    <span className="fw-light m-0 d-block">28 July 2022</span>
                  </div>
                  <div className="d-flex align-items-center justify-content-between">
                    <span className="fw-light m-0 d-block">Product :</span>
                    <span className="fw-light m-0 d-block">1</span>
                  </div>
                  <div className="d-flex align-items-center justify-content-between">
                    <span className="fw-light m-0 d-block">Sub-total :</span>
                    <span className="fw-light m-0 d-block">$ 51.00</span>
                  </div>
                  <div className="d-flex align-items-center justify-content-between pb-1">
                    <span className="fw-light m-0 d-block">
                      Courier Charge :
                    </span>
                    <span className="fw-light m-0 d-block">$ 1.00</span>
                  </div>
                  <div className="d-flex align-items-center justify-content-between pb-1">
                    <span className="fw-light m-0 d-block">
                      Applied Coupon :
                    </span>
                    <span className="fw-light m-0 d-block">No</span>
                  </div>
                  <div className="d-flex align-items-center justify-content-between pb-1">
                    <span className="fw-light m-0 d-block">Discount :</span>
                    <span className="fw-light m-0 d-block">$ 0.00</span>
                  </div>
                  <div className="d-flex align-items-center justify-content-between pt-1 border-top">
                    <span className="fw-normal m-0 d-block">Total :</span>
                    <span className="fw-normal m-0 d-block">$ 52.00</span>
                  </div>
                </div>
              </div>
            </div>
            {/* order heading end  */}
          </div>
        </div>
      </Container>
    </div>
  );
};

export default TrackOrderDetails;
